export default __webpack_public_path__ + "fonts/Roboto-Medium.7c8d04cd.ttf";